import { Outlet } from "react-router-dom";
import AdminSidebar from "./Sidebar";

// AdminSidebar component should include <Outlet /> where child pages will render
export function AdminLayout() {
  return (
    <div className="flex">
      <AdminSidebar />
      <div className="flex-1 p-4">
        <Outlet />
      </div>
    </div>
  );
}